var _g, _path, _path2, _g2, _path3, _path4, _path5, _g3, _path6, _path7, _path8, _path9, _path10, _g4, _path11, _path12, _path13, _path14, _g5, _path15, _path16, _path17, _path18, _path19, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.226 404.456C317.118 404.456 401.338 320.236 401.338 216.344C401.338 112.453 317.118 28.2329 213.226 28.2329C109.335 28.2329 25.1149 112.453 25.1149 216.344C25.1149 320.236 109.335 404.456 213.226 404.456Z",
    fill: "url(#paint0_radial_1022_17273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.226 404.456C317.118 404.456 401.338 320.236 401.338 216.344C401.338 112.453 317.118 28.2329 213.226 28.2329C109.335 28.2329 25.1149 112.453 25.1149 216.344C25.1149 320.236 109.335 404.456 213.226 404.456Z",
    fill: "url(#paint1_radial_1022_17273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.226 404.456C317.118 404.456 401.338 320.236 401.338 216.344C401.338 112.453 317.118 28.2329 213.226 28.2329C109.335 28.2329 25.1149 112.453 25.1149 216.344C25.1149 320.236 109.335 404.456 213.226 404.456Z",
    fill: "url(#paint2_radial_1022_17273)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M122.736 256.038C133.285 256.038 143.402 251.848 150.861 244.388C158.32 236.929 162.511 226.812 162.511 216.263C162.511 205.714 158.32 195.597 150.861 188.138C143.402 180.679 133.285 176.488 122.736 176.488C112.187 176.488 102.07 180.679 94.6106 188.138C87.1514 195.597 82.9608 205.714 82.9608 216.263C82.9608 226.812 87.1514 236.929 94.6106 244.388C102.07 251.848 112.187 256.038 122.736 256.038Z",
    fill: "url(#paint3_radial_1022_17273)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M300.374 256.038C310.923 256.038 321.04 251.848 328.5 244.388C335.959 236.929 340.149 226.812 340.149 216.263C340.149 205.714 335.959 195.597 328.5 188.138C321.04 180.679 310.923 176.488 300.374 176.488C289.825 176.488 279.708 180.679 272.249 188.138C264.79 195.597 260.599 205.714 260.599 216.263C260.599 226.812 264.79 236.929 272.249 244.388C279.708 251.848 289.825 256.038 300.374 256.038Z",
    fill: "url(#paint4_radial_1022_17273)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.405 109.302C215.304 109.302 223.838 105.767 230.131 99.4746C236.423 93.1821 239.958 84.6477 239.958 75.7488C239.958 66.8498 236.423 58.3154 230.131 52.0229C223.838 45.7304 215.304 42.1953 206.405 42.1953C197.506 42.1953 188.972 45.7304 182.679 52.0229C176.387 58.3154 172.852 66.8498 172.852 75.7488C172.852 84.6477 176.387 93.1821 182.679 99.4746C188.972 105.767 197.506 109.302 206.405 109.302Z",
    stroke: "url(#paint5_linear_1022_17273)",
    strokeWidth: 3.35937
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.403 109.302C215.302 109.302 223.836 105.767 230.129 99.4746C236.421 93.1821 239.956 84.6477 239.956 75.7488C239.956 66.8498 236.421 58.3154 230.129 52.0229C223.836 45.7304 215.302 42.1953 206.403 42.1953C197.504 42.1953 188.969 45.7304 182.677 52.0229C176.384 58.3154 172.849 66.8498 172.849 75.7488C172.849 84.6477 176.384 93.1821 182.677 99.4746C188.969 105.767 197.504 109.302 206.403 109.302Z",
    fill: "url(#paint6_linear_1022_17273)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.403 109.302C215.302 109.302 223.836 105.767 230.129 99.4746C236.421 93.1821 239.956 84.6477 239.956 75.7488C239.956 66.8498 236.421 58.3154 230.129 52.0229C223.836 45.7304 215.302 42.1953 206.403 42.1953C197.504 42.1953 188.969 45.7304 182.677 52.0229C176.384 58.3154 172.849 66.8498 172.849 75.7488C172.849 84.6477 176.384 93.1821 182.677 99.4746C188.969 105.767 197.504 109.302 206.403 109.302Z",
    fill: "url(#paint7_radial_1022_17273)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M206.403 109.302C215.302 109.302 223.836 105.767 230.129 99.4746C236.421 93.1821 239.956 84.6477 239.956 75.7488C239.956 66.8498 236.421 58.3154 230.129 52.0229C223.836 45.7304 215.302 42.1953 206.403 42.1953C197.504 42.1953 188.969 45.7304 182.677 52.0229C176.384 58.3154 172.849 66.8498 172.849 75.7488C172.849 84.6477 176.384 93.1821 182.677 99.4746C188.969 105.767 197.504 109.302 206.403 109.302Z",
    fill: "url(#paint8_radial_1022_17273)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8065 205.018C34.1974 203.358 40.8577 203.005 47.3883 203.981C53.9188 204.956 60.1853 207.24 65.8123 210.695C71.4392 214.15 76.3108 218.705 80.1352 224.088C83.9596 229.47 86.658 235.57 88.0688 242.02C89.4796 248.471 89.5738 255.14 88.3457 261.628C87.1176 268.115 84.5925 274.288 80.9216 279.777C77.2508 285.266 72.5098 289.957 66.9826 293.569C61.4555 297.182 55.256 299.641 48.7556 300.801",
    stroke: "url(#paint9_linear_1022_17273)",
    strokeWidth: 2.6875
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3929 205.729C31.938 203.638 38.8492 202.946 45.679 203.696C52.5087 204.447 59.1046 206.624 65.0395 210.086C70.9743 213.548 76.1158 218.218 80.131 223.794C84.1461 229.369 86.9453 235.726 88.3474 242.452C89.7494 249.179 89.7229 256.124 88.2697 262.84C86.8165 269.555 83.9689 275.89 79.9114 281.435C75.8539 286.98 70.677 291.611 64.7159 295.027C58.7548 298.444 52.1425 300.571 45.3073 301.269C30.3491 271.74 23.4824 238.774 25.4063 205.729",
    fill: "url(#paint10_radial_1022_17273)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3929 205.729C31.938 203.638 38.8492 202.946 45.679 203.696C52.5087 204.447 59.1046 206.624 65.0395 210.086C70.9743 213.548 76.1158 218.218 80.131 223.794C84.1461 229.369 86.9453 235.726 88.3474 242.452C89.7494 249.179 89.7229 256.124 88.2697 262.84C86.8165 269.555 83.9689 275.89 79.9114 281.435C75.8539 286.98 70.677 291.611 64.7159 295.027C58.7548 298.444 52.1425 300.571 45.3073 301.269C30.3491 271.74 23.4824 238.774 25.4063 205.729",
    fill: "url(#paint11_radial_1022_17273)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3929 205.729C31.938 203.638 38.8492 202.946 45.679 203.696C52.5087 204.447 59.1046 206.624 65.0395 210.086C70.9743 213.548 76.1158 218.218 80.131 223.794C84.1461 229.369 86.9453 235.726 88.3474 242.452C89.7494 249.179 89.7229 256.124 88.2697 262.84C86.8165 269.555 83.9689 275.89 79.9114 281.435C75.8539 286.98 70.677 291.611 64.7159 295.027C58.7548 298.444 52.1425 300.571 45.3073 301.269C30.3491 271.74 23.4824 238.774 25.4063 205.729",
    fill: "url(#paint12_radial_1022_17273)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3929 205.729C31.938 203.638 38.8492 202.946 45.679 203.696C52.5087 204.447 59.1046 206.624 65.0395 210.086C70.9743 213.548 76.1158 218.218 80.131 223.794C84.1461 229.369 86.9453 235.726 88.3474 242.452C89.7494 249.179 89.7229 256.124 88.2697 262.84C86.8165 269.555 83.9689 275.89 79.9114 281.435C75.8539 286.98 70.677 291.611 64.7159 295.027C58.7548 298.444 52.1425 300.571 45.3073 301.269C30.3491 271.74 23.4824 238.774 25.4063 205.729",
    fill: "url(#paint13_radial_1022_17273)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3929 205.729C31.938 203.638 38.8492 202.946 45.679 203.696C52.5087 204.447 59.1046 206.624 65.0395 210.086C70.9743 213.548 76.1158 218.218 80.131 223.794C84.1461 229.369 86.9453 235.726 88.3474 242.452C89.7494 249.179 89.7229 256.124 88.2697 262.84C86.8165 269.555 83.9689 275.89 79.9114 281.435C75.8539 286.98 70.677 291.611 64.7159 295.027C58.7548 298.444 52.1425 300.571 45.3073 301.269C30.3491 271.74 23.4824 238.774 25.4063 205.729",
    fill: "url(#paint14_radial_1022_17273)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.96 305.691C211.069 316.737 214.926 335.402 205.56 347.374C196.194 359.334 177.153 360.073 163.03 349.027C148.921 337.968 145.078 319.317 154.43 307.344C163.81 295.385 182.851 294.632 196.96 305.691Z",
    stroke: "url(#paint15_linear_1022_17273)",
    strokeWidth: 2.6875
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M196.96 305.691C211.069 316.737 214.926 335.402 205.56 347.374C196.194 359.334 177.153 360.073 163.03 349.027C148.921 337.968 145.078 319.317 154.43 307.344C163.81 295.385 182.851 294.632 196.96 305.691Z",
    fill: "url(#paint16_linear_1022_17273)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196.96 305.691C211.069 316.737 214.926 335.402 205.56 347.374C196.194 359.334 177.153 360.073 163.03 349.027C148.921 337.968 145.078 319.317 154.43 307.344C163.81 295.385 182.851 294.632 196.96 305.691Z",
    fill: "url(#paint17_radial_1022_17273)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.96 305.691C211.069 316.737 214.926 335.402 205.56 347.374C196.194 359.334 177.153 360.073 163.03 349.027C148.921 337.968 145.078 319.317 154.43 307.344C163.81 295.385 182.851 294.632 196.96 305.691Z",
    fill: "url(#paint18_radial_1022_17273)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M349.727 345.786C326.86 369.927 298.001 387.575 266.092 396.93C259.954 385.866 258.327 372.859 261.552 360.624C264.777 348.39 272.603 337.874 283.398 331.273C294.192 324.673 307.119 322.497 319.478 325.202C331.838 327.906 342.676 335.281 349.727 345.786Z",
    fill: "#6B438B"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.797 230.79C389.44 229.223 380.8 230.888 373.624 235.447C366.447 240.007 361.269 247.12 359.136 255.351C357.003 263.581 358.074 272.315 362.132 279.786C366.191 287.257 372.935 292.909 381 295.599",
    stroke: "url(#paint19_linear_1022_17273)",
    strokeWidth: 4.03125
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M400.744 231.461C398.972 253.947 393.144 275.927 383.544 296.337C379.2 295.287 375.108 293.379 371.51 290.726C367.913 288.073 364.881 284.729 362.594 280.888C360.306 277.048 358.809 272.789 358.189 268.362C357.57 263.935 357.841 259.429 358.986 255.108C360.132 250.788 362.129 246.739 364.86 243.2C367.591 239.662 371.002 236.704 374.892 234.502C378.781 232.299 383.072 230.895 387.511 230.373C391.951 229.851 396.45 230.221 400.744 231.461Z",
    fill: "url(#paint20_radial_1022_17273)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M400.744 231.461C398.972 253.947 393.144 275.927 383.544 296.337C379.2 295.287 375.108 293.379 371.51 290.726C367.913 288.073 364.881 284.729 362.594 280.888C360.306 277.048 358.809 272.789 358.189 268.362C357.57 263.935 357.841 259.429 358.986 255.108C360.132 250.788 362.129 246.739 364.86 243.2C367.591 239.662 371.002 236.704 374.892 234.502C378.781 232.299 383.072 230.895 387.511 230.373C391.951 229.851 396.45 230.221 400.744 231.461Z",
    fill: "url(#paint21_radial_1022_17273)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M400.744 231.461C398.972 253.947 393.144 275.927 383.544 296.337C379.2 295.287 375.108 293.379 371.51 290.726C367.913 288.073 364.881 284.729 362.594 280.888C360.306 277.048 358.809 272.789 358.189 268.362C357.57 263.935 357.841 259.429 358.986 255.108C360.132 250.788 362.129 246.739 364.86 243.2C367.591 239.662 371.002 236.704 374.892 234.502C378.781 232.299 383.072 230.895 387.511 230.373C391.951 229.851 396.45 230.221 400.744 231.461Z",
    fill: "url(#paint22_radial_1022_17273)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M400.744 231.461C398.972 253.947 393.144 275.927 383.544 296.337C379.2 295.287 375.108 293.379 371.51 290.726C367.913 288.073 364.881 284.729 362.594 280.888C360.306 277.048 358.809 272.789 358.189 268.362C357.57 263.935 357.841 259.429 358.986 255.108C360.132 250.788 362.129 246.739 364.86 243.2C367.591 239.662 371.002 236.704 374.892 234.502C378.781 232.299 383.072 230.895 387.511 230.373C391.951 229.851 396.45 230.221 400.744 231.461Z",
    fill: "url(#paint23_radial_1022_17273)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M400.744 231.461C398.972 253.947 393.144 275.927 383.544 296.337C379.2 295.287 375.108 293.379 371.51 290.726C367.913 288.073 364.881 284.729 362.594 280.888C360.306 277.048 358.809 272.789 358.189 268.362C357.57 263.935 357.841 259.429 358.986 255.108C360.132 250.788 362.129 246.739 364.86 243.2C367.591 239.662 371.002 236.704 374.892 234.502C378.781 232.299 383.072 230.895 387.511 230.373C391.951 229.851 396.45 230.221 400.744 231.461Z",
    fill: "url(#paint24_radial_1022_17273)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.612 109.839C132.775 109.842 124.3 113.355 118.051 119.603C111.803 125.852 108.29 134.327 108.287 143.164C108.287 144.946 107.579 146.655 106.319 147.915C105.059 149.175 103.35 149.883 101.568 149.883C99.7862 149.883 98.0773 149.175 96.8172 147.915C95.5572 146.655 94.8494 144.946 94.8494 143.164C94.8529 130.763 99.7808 118.871 108.55 110.102C117.319 101.333 129.211 96.4049 141.612 96.4014C143.394 96.4014 145.103 97.1092 146.363 98.3692C147.623 99.6293 148.331 101.338 148.331 103.12C148.331 104.902 147.623 106.611 146.363 107.871C145.103 109.131 143.394 109.839 141.612 109.839Z",
    fill: "url(#paint25_linear_1022_17273)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.612 109.839C132.775 109.842 124.3 113.355 118.051 119.603C111.803 125.852 108.29 134.327 108.287 143.164C108.287 144.946 107.579 146.655 106.319 147.915C105.059 149.175 103.35 149.883 101.568 149.883C99.7862 149.883 98.0773 149.175 96.8172 147.915C95.5572 146.655 94.8494 144.946 94.8494 143.164C94.8529 130.763 99.7808 118.871 108.55 110.102C117.319 101.333 129.211 96.4049 141.612 96.4014C143.394 96.4014 145.103 97.1092 146.363 98.3692C147.623 99.6293 148.331 101.338 148.331 103.12C148.331 104.902 147.623 106.611 146.363 107.871C145.103 109.131 143.394 109.839 141.612 109.839Z",
    fill: "url(#paint26_radial_1022_17273)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.379 103.121C274.379 101.339 275.087 99.6297 276.347 98.3697C277.607 97.1097 279.315 96.4019 281.097 96.4019C293.499 96.4054 305.391 101.333 314.16 110.102C322.928 118.871 327.856 130.763 327.86 143.164C327.86 144.946 327.152 146.655 325.892 147.915C324.632 149.175 322.923 149.883 321.141 149.883C319.359 149.883 317.65 149.175 316.39 147.915C315.13 146.655 314.422 144.946 314.422 143.164C314.419 134.327 310.907 125.853 304.658 119.604C298.409 113.355 289.935 109.843 281.097 109.839C279.315 109.839 277.607 109.131 276.347 107.871C275.087 106.611 274.379 104.903 274.379 103.121Z",
    fill: "url(#paint27_linear_1022_17273)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.379 103.121C274.379 101.339 275.087 99.6297 276.347 98.3697C277.607 97.1097 279.315 96.4019 281.097 96.4019C293.499 96.4054 305.391 101.333 314.16 110.102C322.928 118.871 327.856 130.763 327.86 143.164C327.86 144.946 327.152 146.655 325.892 147.915C324.632 149.175 322.923 149.883 321.141 149.883C319.359 149.883 317.65 149.175 316.39 147.915C315.13 146.655 314.422 144.946 314.422 143.164C314.419 134.327 310.907 125.853 304.658 119.604C298.409 113.355 289.935 109.843 281.097 109.839C279.315 109.839 277.607 109.131 276.347 107.871C275.087 106.611 274.379 104.903 274.379 103.121Z",
    fill: "url(#paint28_radial_1022_17273)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.981 155.831C150.274 155.855 146.647 154.76 143.573 152.688C140.5 150.617 138.123 147.666 136.754 144.221C135.741 141.785 133.814 139.843 131.385 138.812C128.957 137.781 126.221 137.743 123.765 138.708C121.309 139.672 119.329 141.56 118.25 143.968C117.171 146.376 117.08 149.111 117.995 151.585C120.842 158.801 125.8 164.99 132.22 169.343C138.64 173.697 146.224 176.013 153.981 175.988C171.073 175.988 185.613 164.888 190.692 149.449C191.456 146.931 191.205 144.215 189.993 141.88C188.781 139.546 186.705 137.777 184.207 136.953C181.709 136.128 178.987 136.313 176.624 137.468C174.26 138.623 172.442 140.656 171.557 143.133C169.111 150.524 162.151 155.831 153.981 155.831Z",
    fill: "url(#paint29_linear_1022_17273)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.981 155.831C150.274 155.855 146.647 154.76 143.573 152.688C140.5 150.617 138.123 147.666 136.754 144.221C135.741 141.785 133.814 139.843 131.385 138.812C128.957 137.781 126.221 137.743 123.765 138.708C121.309 139.672 119.329 141.56 118.25 143.968C117.171 146.376 117.08 149.111 117.995 151.585C120.842 158.801 125.8 164.99 132.22 169.343C138.64 173.697 146.224 176.013 153.981 175.988C171.073 175.988 185.613 164.888 190.692 149.449C191.456 146.931 191.205 144.215 189.993 141.88C188.781 139.546 186.705 137.777 184.207 136.953C181.709 136.128 178.987 136.313 176.624 137.468C174.26 138.623 172.442 140.656 171.557 143.133C169.111 150.524 162.151 155.831 153.981 155.831Z",
    fill: "url(#paint30_radial_1022_17273)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.814 155.831C266.107 155.855 262.48 154.76 259.406 152.688C256.333 150.617 253.956 147.666 252.587 144.221C252.122 142.964 251.411 141.813 250.496 140.834C249.58 139.855 248.479 139.068 247.255 138.52C246.032 137.972 244.712 137.674 243.372 137.642C242.032 137.611 240.7 137.847 239.452 138.336C238.205 138.826 237.067 139.56 236.107 140.495C235.146 141.429 234.382 142.546 233.858 143.78C233.334 145.013 233.062 146.339 233.057 147.679C233.052 149.02 233.314 150.347 233.828 151.585C236.675 158.801 241.633 164.99 248.053 169.343C254.473 173.697 262.057 176.013 269.814 175.988C286.906 175.988 301.446 164.888 306.525 149.449C307.289 146.931 307.038 144.215 305.826 141.88C304.614 139.546 302.538 137.777 300.04 136.953C297.542 136.128 294.82 136.313 292.457 137.468C290.093 138.623 288.275 140.656 287.39 143.133C284.944 150.524 277.984 155.831 269.814 155.831Z",
    fill: "url(#paint31_linear_1022_17273)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.814 155.831C266.107 155.855 262.48 154.76 259.406 152.688C256.333 150.617 253.956 147.666 252.587 144.221C252.122 142.964 251.411 141.813 250.496 140.834C249.58 139.855 248.479 139.068 247.255 138.52C246.032 137.972 244.712 137.674 243.372 137.642C242.032 137.611 240.7 137.847 239.452 138.336C238.205 138.826 237.067 139.56 236.107 140.495C235.146 141.429 234.382 142.546 233.858 143.78C233.334 145.013 233.062 146.339 233.057 147.679C233.052 149.02 233.314 150.347 233.828 151.585C236.675 158.801 241.633 164.99 248.053 169.343C254.473 173.697 262.057 176.013 269.814 175.988C286.906 175.988 301.446 164.888 306.525 149.449C307.289 146.931 307.038 144.215 305.826 141.88C304.614 139.546 302.538 137.777 300.04 136.953C297.542 136.128 294.82 136.313 292.457 137.468C290.093 138.623 288.275 140.656 287.39 143.133C284.944 150.524 277.984 155.831 269.814 155.831Z",
    fill: "url(#paint32_radial_1022_17273)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_di_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.842 263.529C146.732 265.416 149.293 266.476 151.964 266.476C154.635 266.476 157.196 265.416 159.086 263.529C165.974 256.634 174.154 251.164 183.158 247.432C192.162 243.7 201.813 241.78 211.559 241.78C221.306 241.78 230.956 243.7 239.96 247.432C248.964 251.164 257.144 256.634 264.033 263.529C265.943 265.309 268.47 266.278 271.081 266.232C273.692 266.186 276.183 265.128 278.029 263.282C279.876 261.435 280.934 258.944 280.98 256.333C281.026 253.722 280.056 251.195 278.276 249.285C269.515 240.523 259.114 233.572 247.667 228.83C236.219 224.087 223.95 221.647 211.559 221.647C199.168 221.647 186.899 224.087 175.451 228.83C164.004 233.572 153.603 240.523 144.842 249.285C142.955 251.175 141.895 253.736 141.895 256.407C141.895 259.078 142.955 261.639 144.842 263.529Z",
    fill: "#352046"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.842 263.529C146.732 265.416 149.293 266.476 151.964 266.476C154.635 266.476 157.196 265.416 159.086 263.529C165.974 256.634 174.154 251.164 183.158 247.432C192.162 243.7 201.813 241.78 211.559 241.78C221.306 241.78 230.956 243.7 239.96 247.432C248.964 251.164 257.144 256.634 264.033 263.529C265.943 265.309 268.47 266.278 271.081 266.232C273.692 266.186 276.183 265.128 278.029 263.282C279.876 261.435 280.934 258.944 280.98 256.333C281.026 253.722 280.056 251.195 278.276 249.285C269.515 240.523 259.114 233.572 247.667 228.83C236.219 224.087 223.95 221.647 211.559 221.647C199.168 221.647 186.899 224.087 175.451 228.83C164.004 233.572 153.603 240.523 144.842 249.285C142.955 251.175 141.895 253.736 141.895 256.407C141.895 259.078 142.955 261.639 144.842 263.529Z",
    fill: "url(#paint33_linear_1022_17273)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.842 263.529C146.732 265.416 149.293 266.476 151.964 266.476C154.635 266.476 157.196 265.416 159.086 263.529C165.974 256.634 174.154 251.164 183.158 247.432C192.162 243.7 201.813 241.78 211.559 241.78C221.306 241.78 230.956 243.7 239.96 247.432C248.964 251.164 257.144 256.634 264.033 263.529C265.943 265.309 268.47 266.278 271.081 266.232C273.692 266.186 276.183 265.128 278.029 263.282C279.876 261.435 280.934 258.944 280.98 256.333C281.026 253.722 280.056 251.195 278.276 249.285C269.515 240.523 259.114 233.572 247.667 228.83C236.219 224.087 223.95 221.647 211.559 221.647C199.168 221.647 186.899 224.087 175.451 228.83C164.004 233.572 153.603 240.523 144.842 249.285C142.955 251.175 141.895 253.736 141.895 256.407C141.895 259.078 142.955 261.639 144.842 263.529Z",
    fill: "url(#paint34_linear_1022_17273)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.092 256.309C171.382 237.282 224.151 210.622 272.862 256.309",
    stroke: "url(#paint35_linear_1022_17273)",
    strokeWidth: 6.71875,
    strokeLinecap: "round"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.896 106.883C119.245 110.377 103.953 120.952 102.381 142.264",
    stroke: "url(#paint36_linear_1022_17273)",
    strokeWidth: 6.71875,
    strokeLinecap: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.256 102.165C292.597 101.184 318.505 105.82 322.2 136.39",
    stroke: "url(#paint37_linear_1022_17273)",
    strokeWidth: 6.71875,
    strokeLinecap: "round"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.305 145.333C127.702 152.468 139.245 166.416 157.386 165.073C175.526 163.729 182.715 152.186 184.664 145.319",
    stroke: "url(#paint38_linear_1022_17273)",
    strokeWidth: 8.0625,
    strokeLinecap: "round"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.959 145.333C241.356 152.468 252.899 166.416 271.04 165.073C289.18 163.729 296.369 152.186 298.331 145.319",
    stroke: "url(#paint39_linear_1022_17273)",
    strokeWidth: 8.0625,
    strokeLinecap: "round"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_1022_17273)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_i_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.707 191.77C114.707 198.983 120.589 204.831 127.845 204.831C135.101 204.831 140.984 198.983 140.984 191.77C140.984 185.148 129.912 165.707 128.096 162.563C127.981 162.364 127.71 162.364 127.595 162.563C125.779 165.707 114.707 185.148 114.707 191.77Z",
    fill: "url(#paint40_linear_1022_17273)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.591 193.053C122.591 197.381 126.12 200.889 130.473 200.889C134.827 200.889 138.356 197.381 138.356 193.053C138.356 189.076 131.702 177.395 130.621 175.524C130.553 175.406 130.394 175.406 130.326 175.524C129.245 177.395 122.591 189.076 122.591 193.053Z",
    fill: "#63BAE0"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_di_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.989 214.221C93.989 218.105 97.1564 221.254 101.063 221.254C104.971 221.254 108.138 218.105 108.138 214.221C108.138 210.655 102.176 200.187 101.198 198.494C101.136 198.387 100.991 198.387 100.929 198.494C99.9508 200.187 93.989 210.655 93.989 214.221Z",
    fill: "url(#paint41_linear_1022_17273)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_1022_17273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.2353 214.911C98.2353 217.241 100.136 219.131 102.48 219.131C104.824 219.131 106.725 217.241 106.725 214.911C106.725 212.77 103.142 206.48 102.559 205.472C102.523 205.409 102.437 205.409 102.4 205.472C101.818 206.48 98.2353 212.77 98.2353 214.911Z",
    fill: "#63BAE0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1022_17273",
    x: 25.1149,
    y: 24.8735,
    width: 376.223,
    height: 379.583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.35937
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.0781
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.509804 0 0 0 0 0.396078 0 0 0 0 0.631373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1022_17273",
    x: 167.813,
    y: 37.1563,
    width: 77.1851,
    height: 77.1851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67969,
    result: "effect1_foregroundBlur_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1022_17273",
    x: 23.4374,
    y: 198.067,
    width: 71.1394,
    height: 108.087,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.01562,
    result: "effect1_foregroundBlur_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1022_17273",
    x: 143.939,
    y: 292.489,
    width: 72.1182,
    height: 69.7358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.01562,
    result: "effect1_foregroundBlur_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1022_17273",
    x: 352.688,
    y: 224.84,
    width: 48.8406,
    height: 76.0298,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67969,
    result: "effect1_foregroundBlur_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1022_17273",
    x: 89.4744,
    y: 93.042,
    width: 64.2312,
    height: 64.2314,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.01562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.6875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.0862745 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1022_17273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1022_17273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1022_17273",
    x: 269.004,
    y: 95.0581,
    width: 61.5437,
    height: 61.5439,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.34375,
    dy: 2.6875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.01562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.0862745 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1022_17273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1022_17273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1022_17273",
    x: 109.307,
    y: 133.085,
    width: 84.5068,
    height: 50.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.6875,
    dy: 2.01562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.6875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.0862745 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1022_17273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1022_17273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1022_17273",
    x: 224.994,
    y: 133.085,
    width: 84.6523,
    height: 50.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.6875,
    dy: 2.01562
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.6875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.0862745 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1022_17273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1022_17273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_di_1022_17273",
    x: 121.738,
    y: 208.209,
    width: 172.68,
    height: 78.4233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.35937,
    dy: 3.35937
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.39844
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223529 0 0 0 0 0.133333 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1022_17273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1022_17273",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.35937
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67969
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.101961 0 0 0 0 0.211765 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1022_17273",
    x: 143.701,
    y: 223.695,
    width: 136.552,
    height: 40.0044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.01562,
    result: "effect1_foregroundBlur_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_1022_17273",
    x: 95.6616,
    y: 100.164,
    width: 36.9541,
    height: 48.8188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67969,
    result: "effect1_foregroundBlur_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_1022_17273",
    x: 274.537,
    y: 95.3291,
    width: 54.3821,
    height: 47.7803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.67969,
    result: "effect1_foregroundBlur_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_1022_17273",
    x: 116.898,
    y: 135.912,
    width: 77.1733,
    height: 38.6572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.6875,
    result: "effect1_foregroundBlur_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_1022_17273",
    x: 230.552,
    y: 135.912,
    width: 77.1868,
    height: 38.6572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.6875,
    result: "effect1_foregroundBlur_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_1022_17273",
    x: 105.308,
    y: 162.414,
    width: 45.0744,
    height: 61.2148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.39891
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.69945
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1022_17273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1022_17273",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_i_1022_17273",
    x: 114.707,
    y: 162.414,
    width: 26.2766,
    height: 51.8159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.39891
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.69945
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_1022_17273",
    x: 117.891,
    y: 170.736,
    width: 25.1648,
    height: 34.8525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.34973,
    result: "effect1_foregroundBlur_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_di_1022_17273",
    x: 84.5901,
    y: 198.414,
    width: 32.9467,
    height: 41.6381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.39891
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.69945
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1022_17273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1022_17273",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.34973
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.69945
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1022_17273"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_1022_17273",
    x: 93.5359,
    y: 200.725,
    width: 17.8882,
    height: 23.105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.34973,
    result: "effect1_foregroundBlur_1022_17273"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(287.155 158.844) rotate(139.682) scale(276.473 287.286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A27ACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60348C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.865 216.344) rotate(171.533) scale(259.824 417.263)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#544269",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544269"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4726 286.404) rotate(-14.58) scale(169.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#453C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453C50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.669 216.21) scale(39.7199 39.7199)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8585D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8585D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(300.415 216.21) scale(39.7199 39.7199)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#E35387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E35387",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1022_17273",
    x1: 239.958,
    y1: 71.5159,
    x2: 178.791,
    y2: 87.4662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D4993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D61B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1022_17273",
    x1: 172.849,
    y1: 75.7487,
    x2: 233.802,
    y2: 75.7487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996BBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B569B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.585 75.7487) scale(53.7708 51.238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#64487E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64487E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(213.982 75.7487) rotate(180) scale(42.95 42.7918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#A87ACF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A87ACF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1022_17273",
    x1: 76.7593,
    y1: 276.855,
    x2: 33.9206,
    y2: 194.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504163"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.246 256.697) rotate(-22.4794) scale(52.7165 56.3425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#524262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A395D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.9485 249.552) rotate(168.69) scale(40.6826 115.871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#6A6373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6373"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.9347 249.563) rotate(168.257) scale(39.4587 112.385)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#5B5167",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5167"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.8113 256.267) rotate(-75.256) scale(53.6259 52.8918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#624C7A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#624C7A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0754 234.807) rotate(84.261) scale(66.7757 53.5593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#57545C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57545C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1022_17273",
    x1: 193.91,
    y1: 302.883,
    x2: 166.618,
    y2: 347.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#563775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52336B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1022_17273",
    x1: 151.501,
    y1: 309.185,
    x2: 213.233,
    y2: 341.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#583676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E407C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.002 312.733) rotate(86.2801) scale(46.2737 36.4598)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#674F7D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#674F7D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.002 334.837) rotate(-119.743) scale(40.7327 35.3354)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#4F2D6E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F2D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1022_17273",
    x1: 379.469,
    y1: 230.239,
    x2: 379.469,
    y2: 296.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8059AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9169BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(361.467 252.491) rotate(22.9321) scale(35.5647 22.8978)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D6BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C77BF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(363.348 253.969) rotate(13.1575) scale(33.2057 84.7935)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#A385C1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A385C1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(362.617 252.909) rotate(14.591) scale(34.1709 76.8493)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#A385C1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A72BF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(393.582 257.53) rotate(109.614) scale(40.3438 36.8066)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#AF8DCF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF8DCF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(392.118 271.599) rotate(-104.248) scale(41.3753 39.4535)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#7F59A4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F59A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1022_17273",
    x1: 142.055,
    y1: 94.117,
    x2: 92.4575,
    y2: 143.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28212F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.745 100.997) rotate(158.703) scale(11.3062 8.97717)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#48424F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48424F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1022_17273",
    x1: 321.585,
    y1: 94.1175,
    x2: 271.987,
    y2: 143.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28212F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(327.851 149.875) rotate(-122.305) scale(21.185 16.8212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#48424F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48424F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1022_17273",
    x1: 182.522,
    y1: 177.681,
    x2: 151.737,
    y2: 120.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28212F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(189.014 172.57) rotate(-168.151) scale(14.875 7.0137)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#48424F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48424F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1022_17273",
    x1: 298.355,
    y1: 177.681,
    x2: 267.57,
    y2: 120.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28212F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F26"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1022_17273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(304.846 172.577) rotate(-168.151) scale(14.875 7.0137)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#48424F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48424F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1022_17273",
    x1: 143.525,
    y1: 266.485,
    x2: 154.866,
    y2: 257.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#211928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#211928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1022_17273",
    x1: 277.483,
    y1: 264.187,
    x2: 269.502,
    y2: 255.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#584B64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584B64",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1022_17273",
    x1: 275.805,
    y1: 258.835,
    x2: 255.985,
    y2: 213.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3C59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3645"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1022_17273",
    x1: 123.021,
    y1: 103.282,
    x2: 110.443,
    y2: 145.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3A44",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3A44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1022_17273",
    x1: 324.928,
    y1: 143.31,
    x2: 268.41,
    y2: 130.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#3F3A44",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3F3A44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1022_17273",
    x1: 105.732,
    y1: 153.987,
    x2: 121.803,
    y2: 191.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3A44",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3A44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1022_17273",
    x1: 219.386,
    y1: 153.987,
    x2: 235.457,
    y2: 191.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3A44",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3A44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1022_17273",
    x1: 127.845,
    y1: 162.131,
    x2: 127.845,
    y2: 204.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0087C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#135978"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1022_17273",
    x1: 101.063,
    y1: 198.262,
    x2: 101.063,
    y2: 221.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0087C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#135978"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonicon);
export default __webpack_public_path__ + "static/media/moon.icon.18b5576a9047998472298f6e4c176165.svg";
export { ForwardRef as ReactComponent };